<div [ngClass]="{ 'height-full': isHeightFull }" [ngSwitch]="selectedButtonId">

	<video-basic-info *ngSwitchCase="VideoPlaybackSidebarButton.INFO" [video]="video$ | async">
	</video-basic-info>

	<video-comment-container *ngSwitchCase="VideoPlaybackSidebarButton.COMMENTS" [video]="video$ | async">
	</video-comment-container>

	<video-share-container *ngSwitchCase="VideoPlaybackSidebarButton.SHARE" [video]="video$ | async" [mediaFeatures]="mediaFeatures" [playbackPosition]="VideoPlaybackComponent.playbackCurrentTime">
	</video-share-container>

	<video-pulse-container *ngSwitchCase="VideoPlaybackSidebarButton.PULSE" [video]="video$ | async" [currentTimeSec]="VideoPlaybackComponent.playbackCurrentTime / SecondMs" [filter]="VideoPlaybackComponent.sidebarFilter" [vgApi]="VideoPlaybackComponent.vgAPI" [activeSubtitleLang]="VideoPlaybackComponent.vgAPI?.activeSubtitle?.language">
	</video-pulse-container>

	<video-playlist-container *ngSwitchCase="VideoPlaybackSidebarButton.PLAYLIST" [video]="video$ | async" (onCancelPlaylist)="onCloseSidebar.emit()">
	</video-playlist-container>

	<video-chapters-container *ngSwitchCase="VideoPlaybackSidebarButton.CHAPTERS" [video]="video$ | async" (onChapterClick)="clickChapter($event)">
	</video-chapters-container>

</div>